import type { NotifyPort } from '@/features/messages/domain/notify'
import type { PermissionConfiguration, PermissionPort } from '../domain/permission'

const savePermissionConfig = async (
	port: PermissionPort,
	config: PermissionConfiguration,
	notify: NotifyPort,
): Promise<boolean> => {
	try {
		await port.saveConfig(config)
		notify.success('permission.configSaved')
		return true
	} catch {
		notify.error('permission.configSaveFailed')
		return false
	}
}

export { savePermissionConfig }
